import { render, staticRenderFns } from "./GameCountDown.vue?vue&type=template&id=6548f517&scoped=true&"
import script from "./GameCountDown.vue?vue&type=script&lang=js&"
export * from "./GameCountDown.vue?vue&type=script&lang=js&"
import style0 from "./GameCountDown.vue?vue&type=style&index=0&id=6548f517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548f517",
  null
  
)

export default component.exports